<template>
  <div class="channelList">
    <div class="clleft_wap">
      <div class="xllist_wap">
        <!-- <el-dropdown trigger="click" class="xl" @command="handleCommand">
          <span class="el-dropdown-link xl">
            {{listname}}
            <i class="t el-icon-caret-bottom el-icon--right xlfont"></i>
          </span>
          <el-dropdown-menu slot="dropdown" class="mydropdown">
            <el-dropdown-item
              v-for="(item,index) in listcon"
              :key="index"
              :command="item.name"
            >{{item.name}}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>-->

        <span class="el-dropdown-link xl">{{listname.channel_name}}</span>
      </div>
      <div class="xlist_set">
        <div class="xs_o">已选中{{checkList.length}}个分类</div>
        <div class="xs_t">
          <div class="firstbtn" @click="clearcb">清除</div>
          <div @click="pushdata">提交</div>
        </div>
      </div>

      <div class="checkbox_wap">
        <div class="cheackbox_con">
          <div>
            <input id="alls" type="checkbox" v-model="checked" @click="checkedAll" />
            <label for="alls" style="margin-left:5px">全选</label>
          </div>
          <div></div>
        </div>
        <!-- <div class="abcd" @click="titClick">{{listname.channel_name}}</div> -->
        <div class="cheackbox_con" v-for="(item,index) in checkboxlist" :key="index">
          <div>
            <!-- <el-checkbox class="checkstyle">{{item.name}}</el-checkbox> -->
            <input
              :id="item.channel_id"
              type="checkbox"
              v-model="checkList"
              :value="item.channel_id"
            />
            <!-- <label :for="item.channel_id">{{item.channel_name}}</label> -->
            <span
              :class="[actind == index ? 'active' : 'intxt']"
              @click="tit_search(item,index)"
            >{{item.channel_name}}</span>
          </div>
          <div>{{item.total_content_nums}}</div>
        </div>
      </div>
    </div>
    <rightManin
      :rightMainList="rightMainList"
      @no-getData="getcontentData"
      :pages="pageTotal"
      v-if="listShow"
    ></rightManin>
    <div class="misswap" v-else>
      <div class="mw_img">
        <img src="@/assets/conmiss.jpg" alt />
      </div>
      <div class="mw_txto">无内容</div>
      <div class="mw_txtt">抱歉，暂无相关结果请更换搜索词再试一下</div>
    </div>
  </div>
</template>

<script>
import rightManin from "../searchResult/searchResultComponents/rightMain";
import leftManin from "../searchResult/searchResultComponents/leftMenu";
import { channelList, ChannelPage } from "@/api/lyl";

export default {
  data() {
    return {
      actind: -1,
      listShow: true,
      channelId: "",
      pageTotal: 0,
      formlist: "",
      // 子频道id
      channel_ids: "",
      routerQuery_initialState: 0,
      // 下拉列表默认
      listname: [],
      // 选中大复选框
      myvalue: [],
      checked: false, //全选框
      checkList: [],
      // 复选框内容
      checkboxlist: [],
      // 下拉菜单
      // listcon: []
      rigthList: "",
      rightMainList: []
    };
  },

  methods: {
    // 点击标题
    // titClick() {
    //   this.listShow = true;
    //   this.channelId = this.$route.query.initialState;
    //   this.checkList = [];
    //   this.channel_ids = "";
    //   this.actind = -1;
    //   this.rigthList.page.page = 1;
    //   this.rightMainList = "";
    //   console.log('@titclick')
    //   this.ChannePagemeth();
    // },
    // 点击单个列表
    async tit_search(v, i) {
      this.listShow = true;
      this.channelId = "";
      this.checkList = [];
      this.channel_ids = v.channel_id;
      this.actind = i;
      this.rigthList.page.page = 1;
      this.rightMainList = "";
      this.ChannePagemeth();
    },
    // 提交表单
    pushdata() {
      this.channel_ids = this.formlist;
      this.actind = -1;
      this.rightMainList = "";
      this.rigthList.page.page = 1;
      this.listShow = true;
      this.channelId = "";
      this.ChannePagemeth();
    },

    // 频道列表
    async ChannePagemeth() {
      try {
        const data = await ChannelPage({
          channel_id: this.channelId,
          channel_ids: this.channel_ids,
          page: this.rigthList.page.page,
          pageSize: this.rigthList.page.pageSize,
          order_type: this.rigthList.invalidStillRelevant,
          has_img: this.rigthList.layout,
          AudioRights:this.rigthList.audioRights,
          is_auth:this.rigthList.authorizationnumber,
          uid: this.$store.state.userInfo.unique_code,
          p_uid:this.$store.state.userInfo.admin_code  
        });
        (this.rightMainList = data), (this.pageTotal = data.total);
      } catch (err) {
        if (err.code == -1) {
          this.listShow = false;
        } else {
          this.listShow = true;
        }
        // this.$message.error(err.message);
      }
    },
    // 频道列表
    async channe_List() {
      try {
        const data = await channelList({
          channel_id: this.channelId
        });
        this.listname = data.channelList;
        console.log(this.listname);
        let allmylist = {
          channel_name: this.listname.channel_name,
          channel_id: this.$route.query.initialState,
          total_content_nums:this.listname.total_content_nums
        };
        this.checkboxlist = data.channelList.childCate;
        this.checkboxlist.unshift(allmylist);
      } catch (err) {
        this.$message.error(err.message);
      }
    },
    //   下拉列表
    handleCommand(command) {
      this.listname = command;
    },
    // 全选
    checkedAll: function() {
      let that = this;
      that.$nextTick(function() {
        // DOM 现在更新了
      });
      if (that.checked) {
        //实现反选
        that.checkList = [];
      } else {
        //实现全选
        that.checkList = [];
        that.checkboxlist.forEach(function(item, index) {
          that.checkList.push(item.channel_id);
        });
      }
    },
    // 清除表单
    clearcb: function() {
      this.checkList = [];
    },

    getcontentData(res) {
      this.rigthList = res.data;
      this.ChannePagemeth();
    }
  },
  computed:{
    state_artlisttype(){
      console.log('@computed', this.$store.state.artlisttype)
      return this.$store.state.artlisttype
    }
  },
  watch: {
    state_artlisttype(newVal){
      console.log(newVal)
      // this.rightMainList= []
      this.ChannePagemeth()
    },
    "$store.state.userInfo"(n,o){
      this.rightMainList= []
      this.ChannePagemeth()
    },
    //深度 watcher
    // 全选监听
    checkList: {
      handler: function(val, oldVal) {
        this.formlist = val.join(",");
        // this.channel_ids = val.join(",");
        console.log("@checklist", this.channel_ids);
        if (val.length === this.checkboxlist.length) {
          this.checked = true;
        } else {
          this.checked = false;
        }
      },
      deep: true
    },
    pageTotal() {
      this.pageTotal = this.rightMainList.total;
    }
  },
  created() {
    (this.channelId = this.$route.query.initialState),
      // alert(this.listname)
      this.channe_List();
    // this.ChannePagemeth();
  },
  components: {
    rightManin,
    leftManin
  }
};
</script>
<style scoped lang="less">
.cheackbox_con:nth-child(2) div span {
  color: #000;
  font-weight: 600;
}
.abcd {
  cursor: pointer;
  color: #000;
  font-weight: 700;
}
.active {
  color: rgb(23, 81, 153);
  margin-left: 5px;
  // font-size:16px;
}

.misswap {
  width: 800px;
  margin: 40px auto;
  background: #fff;
  padding: 24px 0 40px 0;
  box-sizing: border-box;
  .mw_img {
    width: 702px;
    height: 480px;
    margin: 0 auto;
    img {
      width: 100%;
    }
  }
  .mw_txto {
    font-size: 18px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 25px;
    text-align: center;
  }
  .mw_txtt {
    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: rgba(51, 51, 51, 1);
    line-height: 20px;
    text-align: center;
    margin-top: 11px;
  }
}
.mydropdown {
  /* left: 18.5% !important; */
  width: 320px;
}
input[type="checkbox"] {
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  line-height: 14px;
  position: relative;
  top: -4px;
  width: 18px;
  height: 18px;
  background: rgba(255, 255, 255, 1);
  border-radius: 4px;
  border: 1px solid rgba(204, 204, 204, 1);
}
input[type="checkbox"]::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
  width: 100%;
  height: 100%;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
}
input[type="checkbox"]:checked::before {
  content: "\2713";
  background-color: rgba(21, 47, 106, 1);
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  border: 1px solid rgba(21, 47, 106, 1);
  color: #fff;
  line-height: 16px;
  font-size: 16px;
  font-weight: bold;
  border-radius: 4px;
}
</style>
<style scoped lang="less">
.channelList {
  width: 1200px;
  margin: 40px auto;
  display: flex;
  justify-content: space-between;
}
.clleft_wap {
  width: 360px;
  min-height: 966px;
  padding: 20px 20px 20px 20px;
  box-sizing: border-box;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.1);
  .xllist_wap {
    width: 100%;
    .xl {
      width: 100%;
      display: inline-block;
      font-size: 18px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      outline: none;
    }
    .xlfont {
      float: right;
    }
  }
  .xlist_set {
    width: 100%;
    height: 24px;
    display: flex;
    justify-content: space-between;
    margin-top: 10px;
    .xs_o {
      width: 120px;
      font-size: 12px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(51, 51, 51, 1);
      line-height: 24px;
    }
    .xs_t {
      width: 120px;
      display: flex;
      justify-content: space-between;
      .firstbtn {
        background: rgba(230, 230, 230, 1);
        color: rgba(51, 51, 51, 1);
        cursor: pointer;
      }
      div {
        width: 56px;
        height: 24px;
        background: rgba(21, 47, 106, 1);
        border-radius: 4px;
        font-size: 12px;
        // font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(255, 255, 255, 1);
        line-height: 24px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
  .checkbox_wap {
    width: 100%;
    .cheackbox_con {
      height: 20px;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      // font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      margin: 15px 0;
      cursor: pointer;
      .intxt {
        margin-left: 5px;
      }
      label {
        margin-left: 10px;
        cursor: pointer;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/channelList/channelList.vue